module.exports = __webpack_public_path__ + "img/img_top.4e2a646a.png";